const prefix = '/distribution_shop/api';

const Api = {
  user: {
    login: `${prefix}/account/merchant_user/login`,
    info: `${prefix}/account/merchant_user/info`,
    register: `${prefix}/account/merchant_user/register`,
    register_code: `${prefix}/account/merchant_user/register_code`,
    logout: `${prefix}/account/merchant_user/logout`,
    forget: `${prefix}/account/merchant_user/forget`,
    forget_code: `${prefix}/account/merchant_user/forget_code`,
    account_info: `${prefix}/account/merchant_user/account_info`,
    account_flow: `${prefix}/account/merchant_user/account_flow`,
    withdraw: `${prefix}/account/merchant_user/withdraw`,
  },
  shop: {
    shop_apply_info: `${prefix}/merchant/shop/shop_apply_info`,
    apply_shop_code: `${prefix}/merchant/shop/apply_shop_code`,
    apply_shop: `${prefix}/merchant/shop/apply_shop`,
    shop_info: `${prefix}/merchant/shop/shop_info`,
    modify_shop: `${prefix}/merchant/shop/modify_shop`,
    modify_shop_code: `${prefix}/merchant/shop/modify_shop_code`,
    verify_shop_bank: `${prefix}/merchant/shop/verify_shop_bank`,
    address_config: `${prefix}/merchant/shop/address_config`,
  },
  goods: {
    category: `${prefix}/merchant/sku/category`,
    sku_list: `${prefix}/merchant/sku/sku_list`,
    supplier_sku_list: `${prefix}/merchant/sku/supplier_sku_list`,
    apply_sku: `${prefix}/merchant/sku/apply_sku`,
    sku_draft_info: `${prefix}/merchant/sku/sku_draft_info`,
    approval_sku: `${prefix}/merchant/sku/approval_sku`,
    release_sku: `${prefix}/merchant/sku/release_sku`,
    shelf_sku: `${prefix}/merchant/sku/shelf_sku`,
    del_sku: `${prefix}/merchant/sku/del_sku`,
    comments: `${prefix}/merchant/sku/comments`,
  },
  order: {
    order_list: `${prefix}/merchant/order/order_list`,
    order: `${prefix}/merchant/order/order`,
    shipping_info: `${prefix}/merchant/order/shipping_info`,
    ship_company: `${prefix}/merchant/order/ship_company`,
    ship: `${prefix}/merchant/order/ship`,
    address_list: `${prefix}/merchant/order/address_list`,
    address: `${prefix}/merchant/order/address`,
    restock: `${prefix}/merchant/order/restock`,
    restock_list: `${prefix}/merchant/order/restock_list`,
    restock_ship: `${prefix}/merchant/order/restock_ship`,
    confirm_restock_order: `${prefix}/merchant/order/confirm_restock_order`,
  },
  notice: {
    getNotice: `${prefix}/merchant/notice/content`,
    saveContent: `${prefix}/merchant/notice/save_content`,
  },
};

export default Api;
